import React, { useState, useEffect, useRef } from "react";

const SelectBizYear = ({ bizYear, bizYearList, onYearSearchHandler }) => {
  const [selected, setSelected] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const prev = usePrevious(bizYear);
  useEffect(() => {
    setDataLoaded(false);
    if (bizYear && bizYearList) {
      setDataLoaded(true);
    }
    if (!prev || prev.year !== bizYear.year) {
      setSelected(bizYear);
    }
    return () => {};
  }, [bizYear, bizYearList, selected, prev]);

  function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  function onSelectBizYearHandler(year) {
    setSelected(year);
  }

  return dataLoaded === true ? (
    <div className="input-group">
      <div className="input-group-prepend">
        <span className="input-group-text btn-outline-warning">사업년도</span>
      </div>
      <div className="input-group-prepend">
        <button
          className="btn btn-outline-warning dropdown-toggle"
          type="button"
          style={{ minWidth: "100px" }}
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {selected.year}
        </button>
        <div className="dropdown-menu">
          {bizYearList.map((year) => (
            <button
              key={`biz-year-${year.year}`}
              className={
                selected.year === year.year
                  ? "dropdown-item bg-primary"
                  : "dropdown-item"
              }
              onClick={() => onSelectBizYearHandler(year)}
            >
              {year.year}
            </button>
          ))}
        </div>
      </div>
      <button
        type="button"
        className="btn btn-warning"
        onClick={() => onYearSearchHandler(selected.year)}
      >
        조 회
      </button>
    </div>
  ) : (
    <></>
  );
};

export default SelectBizYear;
